import { createGlobalStyle } from 'styled-components';

export const Modifiers = createGlobalStyle`
  .margin--right {
    margin-right: 6rem;
  }
  .margin__spacer {
    margin-right: .5rem;
  }

  .margin--top {
    margin: 1rem 0 1rem 0;
  }
`;
